import React, { useState } from 'react'
import { Modal, Button, Ratio, Stack } from "react-bootstrap";
import {useDispatch, useSelector } from 'react-redux';
import { setTabplateStoBg,setTabplateStoKo,setTabplateStoSm,setTabplateStoSc,
         delTabplateStoKo,delTabplateStoBg,delTabplateStoSc1,delTabplateStoSc3,
         delTabplateStoSm } from '../../store/modules/tabplate';
import styles from './index.module.css'
import { setStopTimer } from '../../store/modules/timerId';
import { darkenColor } from '../../utils/publicfunction';
import langList from '../../utils/languagelist.json';

// 把颜色代码转为具体的颜色(css中的类名)
function toforecolor(c) {
  switch (c) {
    //字的颜色
    case "b":
      return {color:"Black"}
    case "r":
      return {color:"Red"}
    default:
      return {color:"Black"}
  }
};

//替换字符串中的某数字，例如："b0b0b3b4b0b6b0b0b0"，把b4和b6间的b0替换为r5
function changsml(str,m,s) {
  let arr = str.match(/.{1,2}/g); // 将字符串分割为两个字符的组
  arr[s] = m; // 更改指定的组
  str = arr.join(''); // 将数组重新组合为字符串
  return str;
}

//判断格子中，是否有同行、同列或同宫格的相同的数字，如果没有返回true
function isValid(grid,num,id) {
  const iid=~~(id/9);
  const jid=id%9;

  for(let j=0;j<9;j++){
    if(j!==jid){
      if(grid[iid][j]==="f"+num || grid[iid][j]==="t"+num){
        return false
      }
    }
  };

  for(let i=0;i<9;i++){
    if(i!==iid){
      if(grid[i][jid]==="f"+num || grid[i][jid]==="t"+num){
        return false
      }
    }
  };

  const startRow = ~~(iid / 3) * 3;
  const startCol = ~~(jid / 3) * 3;
  for (let i = startRow; i < startRow + 3; i++) {
    for (let j = startCol; j < startCol + 3; j++) {
      if(!(i===iid && j===jid)){
        if(grid[i][j]==="f"+num || grid[i][j]==="t"+num){
          return false
        }
      }
    }
  }
  
  return true
}

//判断是否完成了
function iscomplete(grid) {
  for(let i=0;i<9;i++){
    for(let j=0;j<9;j++){
      if(grid[i][j].charAt(0)==="k" || grid[i][j].charAt(0)==="h"){
        return false
      }
    }
  }
  for(let i=0;i<9;i++){
    for(let j=0;j<9;j++){
      if(!isValid(grid,grid[i][j].charAt(1),i*9+j)){
        return false
      }
    }
  }
  return true
};

// 判断帮助需显示的节点与当坐标是否相同
// arr是节点数组，rc是当前坐标
function isNode(arr,r,c){
  for(let v of arr){
    if(v[0]===r&&v[1]===c){
      return true;
    }
  }
  return false;
}

export default function Tabbr() {
  const [showAlert, setShowAlert] = useState(false);
  const {t0,tt,un}=useSelector((state)=>state.tabplate);
  const dispatch=useDispatch();

  const {b}=useSelector((state)=>state.btnsel);//面板选择的数字，1-9数字
  const {p}=useSelector((state)=>state.pencil);//pencil按钮状态，false
  const {c}=useSelector((state)=>state.palette);//调色板的状态，数字
  const {r}=useSelector((state)=>state.btnrec);//二元调色板的状态，0和1数字
  const {e}=useSelector((state)=>state.eraser);//橡皮擦的状态，0和1数字 或者 0、1和2数字
  const {node}=useSelector((state)=>state.helpinfo);//help面板显示节点背景色

  // 计时器的ID
  const {timerId}=useSelector((state)=>state.timerId);
  // 九宫格面板背景色
  const {tb}=useSelector((state)=>state.colorplate);
  // 题目单元格背景色
  const darkenedColor = darkenColor(tb, 0.1);
  const buttonStyle = {
    backgroundColor: darkenedColor
  };
  // 单元格背景色
  const {ce}=useSelector((state)=>state.colorplate);
  // 候选数背景色
  const {hx}=useSelector((state)=>state.colorplate);
  // 突出显示颜色
  const {tc}=useSelector((state)=>state.colorplate);
  // 当前语言
  const {lg}=useSelector((state)=>state.language);

  const handleClose = () => setShowAlert(false);
  const handleShow = () => setShowAlert(true);

  const stopTimer = ()=> {
    if (timerId) {
      clearInterval(timerId);
      dispatch(setStopTimer());
    };
  };
  
  //把tt中的单元格内的数字转为二级数组
  let grid=[];
  let tid = 0;
  for (let i = 0; i < 9; i++) {
    grid[i] = [];
    for (let j = 0; j < 9; j++) {
      switch (tt[tid].sh) {
        case 0:
          grid[i][j]="k0"
          break;
        case 1:
          grid[i][j]="t"+tt[tid].nu[0].charAt(1)
          break;
        case 2:
          grid[i][j]="f"+tt[tid].nu[1].charAt(1)
          break;
        case 3:
          grid[i][j]="h"+tt[tid].nu[2].replace(/[^\d]/g, "");
          break;
        default:
          break;
      }
      tid++;
    }
  };
  
  //给显示变量赋值
  const ow = [];const hc= [];
  const cc = [];const k = [];
  const zz = [];const z = [];
  const bg = [];const bo= [];
  tt.forEach((v,i)=>{

    // 块显示的状态**************************************
    ow[i] = [];
    switch (v.sh) {
      case 0:
        ow[i][0]="d-none";ow[i][1]="d-none";ow[i][2]="d-none";
        break;
      case 1:
        ow[i][0]="d-black";ow[i][1]="d-none";ow[i][2]="d-none";
        break;
      case 2:
        ow[i][0]="d-none";ow[i][1]="d-black";ow[i][2]="d-none";
        break;
      case 3:
        ow[i][0]="d-none";ow[i][1]="d-none";ow[i][2]="d-black";
        break;
      default:
        ow[i][0]="d-none";ow[i][1]="d-none";ow[i][2]="d-none";
        break;
    }

    //每个块中字的显示***************************************
    zz[i] = [];cc[i] = []
    v.nu.forEach((m,h)=>{
      if(m==="0"){
        zz[i][h] = ""
      }else{
        switch (h) {
          case 0:
            // 题目字的颜色
            if(b>0 && b===m.charAt(1)*1 && c===0){
              cc[i][h]={color:tc.jz};//当前选择的字突出显示
            }else{
              cc[i][h]=toforecolor(m.charAt(0));
            };
            //显示的字
            zz[i][h]=m.charAt(1);
            break;
          case 1:
            // 完成了的字的颜色
            if(b>0 && b===m.charAt(1)*1 && c===0){
              cc[i][h]=m.charAt(0)==='r'?toforecolor('r'):{color:tc.jz};//当前选择的字突出显示
            }else{
              cc[i][h]=toforecolor(m.charAt(0));
            };
            //显示的字
            zz[i][h]=m.charAt(1);
            break;
          case 2:
            // 候选数字的颜色;
            k[i] = [];
            m.match(/[a-zA-Z]/g).forEach((char,index) => {
              k[i][index]=toforecolor(char);
            });
            // 突出显示候选数字的颜色
            if(node){
              node.tn.forEach((v)=>{
                const rr=v[0];
                const cc=v[1]
                const ii=rr*9+cc
                if(i===ii&&v[2]){
                  const char=(''+v[2])[0]
                  const num=(''+v[2]).slice(1)
                  for(let vv of [...num]){
                    k[i][vv-1]=toforecolor(char);
                  }
                }
              })
              node.sn.forEach((v)=>{
                const rr=v[0];
                const cc=v[1];
                const ii=rr*9+cc;
                if(i===ii&&v[2]){
                  const char=(''+v[2])[0]
                  const num=(''+v[2]).slice(1)
                  if(num!=='0'){
                    for(let vv of [...num]){
                      k[i][vv-1]=toforecolor(char);
                    }
                  }
                }
              })
            }
            //显示的字
            z[i] = [];
            m.match(/\d/g).forEach((char,index) => {
              if(char==="0"){char=""}
              z[i][index] = char;
            });
            break;
          default:
            zz[i][h]=""
            break;
        }
      }
    })

    // 候选数背景颜色***************************************
    hc[i] = [];
    v.sc.forEach((m,h)=>{
      if(b>0 && b===z[i][h]*1 && c===0){
        hc[i][h]={backgroundColor:tc.hz};//突出显示候选数背景色
      }else{
        hc[i][h]={backgroundColor:hx[m]};
      };
    });

    //单元格背景色*****************************************
    if(v.bj==='0'){
      if(node){
        const r=i/9|0;
        const c=i%9;
        const sn=isNode(node.sn,r,c);
        const tn=isNode(node.tn,r,c);
        if(sn){
          bg[i]={backgroundColor:'#00ffff80'};
        };
        if(tn){
          bg[i]={backgroundColor:'#dc143c50'};
        };
        if(!tn&&!sn){
          bg[i]={backgroundColor:'transparent'};
        };
      }else{
        bg[i]={backgroundColor:'transparent'}
      }
    }else{
      if(node){
        const r=i/9|0;
        const c=i%9;
        const sn=isNode(node.sn,r,c);
        const tn=isNode(node.tn,r,c);
        if(sn){
          bg[i]={backgroundColor:'#00ffff80'};
        };
        if(tn){
          bg[i]={backgroundColor:'#dc143c80'};
        };
        if(!tn&&!sn){
          bg[i]={backgroundColor:ce['b'+v.bj]};
        };
      }else{
        bg[i]={backgroundColor:ce['b'+v.bj]}
      }
    }
    

    //当前（被点击后的）单元格加边框**************************
    bo[i]= i===t0-1 ? "dln" : ""

  });
  
  //光标设定
  let cur;
  switch (true) {
    case e>0:
      cur=styles.erasercur
      break;
    case c>0:
      cur=styles.palettecur
      break;
    default:
      cur=styles.pencilcur
      break;
  };
  
  //单元格内的单击事件
  function clickcell(event) {

    //点击后，单元格选中，有框线
    const id=+event.currentTarget.id
    const ysh=tt[id].sh; //显示项，数字
    const ysm=tt[id].nu[2];//候选数，字符串
    //const yscarray=tt[id].sc;//单元格内候选数颜色，数组
    let ysc=tt[id].sc[b-1];//某个候选数颜色标志，字符

    switch (true) {
      case (e === 0 && !p && c > 0 && b > 0): 
        // 单元格添加背景色
        if(ysh!==1){
          const bj=b.toString()
          const nid=[];const nold=[];
          nid[0]=id;
          nold[0]=tt[id];
          dispatch(setTabplateStoBg({id:id,bj:bj,nid:nid,old:nold,un:un}))
        };
        break;
      case (e === 0 && !p && c === 0 && b > 0):
        // 输入大数字(KO)
        if(ysh!==1){
          const bb=b.toString()
          let sl=isValid(grid,bb,id)?"b"+bb:"r"+bb
          let sh=2;
          if(tt[id].nu[1].charAt(1)===bb){
            sl="0";
            sh=tt[id].nu[2]==='b0b0b0b0b0b0b0b0b0'?0:3}
          const nid=[];const nold=[];
          nid[0]=id;
          nold[0]=tt[id];
          dispatch(setTabplateStoKo({id:id,sl:sl,sh:sh,nid:nid,old:nold,un:un}));
          //判断是否完成
          grid[~~(id/9)][id%9]="f"+bb
          if(iscomplete(grid)){
            stopTimer();
            handleShow();
          }
        }
        break;
      case (e === 0 && p && c === 0 && b > 0):
        // 输入小数字(候选数)
        if(ysh!==1 && ysh!==2){
          const bb=b.toString();
          let sm=isValid(grid,bb,id)?changsml(ysm,"b"+bb,b-1):changsml(ysm,"r"+bb,b-1)
          if(ysm.includes(bb)){
            sm=changsml(ysm,"b0",b-1);
            ysc="0";
          }
          const nid=[];const nold=[];
          nid[0]=id;
          nold[0]=tt[id];
          if(sm==="b0b0b0b0b0b0b0b0b0"){
            dispatch(setTabplateStoSm({id:id,sm:sm,sc:ysc,sl:b-1,sh:0,nid:nid,old:nold,un:un}))
          }else{
            dispatch(setTabplateStoSm({id:id,sm:sm,sc:ysc,sl:b-1,sh:3,nid:nid,old:nold,un:un}))
          }
        }
        break;
      case (e === 0 && p && c > 0 && b > 0):
        // 输入小数字(候选数)的背景色
        if(ysh===3){
          let sca= r<1 ? "a" : "b"
          const sc=sca + c.toString()
          if(sc!==ysc && (c===ysc[1]*1||ysc[0]==='0') && ysm.includes(b.toString())){
            const nid=[];const nold=[];
            nid[0]=id;
            nold[0]=tt[id];
            dispatch(setTabplateStoSc({id:id,sc:sc,sh:3,sl:b-1,nid:nid,old:nold,un:un}))
          }
        }
        break;
      case (e > 0 && !p && c === 0):
        // 橡皮擦擦除大数字(KO)
        if(ysh===2){
          const sl="0"
          const nid=[];const nold=[];
          nid[0]=id;
          nold[0]=tt[id];
          const sh=tt[id].nu[2]==='b0b0b0b0b0b0b0b0b0'?0:3
          dispatch(delTabplateStoKo({id:id,sl:sl,sh:sh,nid:nid,old:nold,un:un}))
        }
        break;
      case (e > 0 && !p && c > 0):
        // 删除单元格背景色
        if(ysh!==1){
          const bj="0"
          const nid=[];const nold=[];
          nid[0]=id;
          nold[0]=tt[id];
          dispatch(delTabplateStoBg({id:id,bj:bj,nid:nid,old:nold,un:un}))
        };
        break;
      case (e === 2 && p && c > 0 && b > 0):
        // 删除单个小数字(候选数)的背景色
        if(ysh===3 && e===2){
          const sc="0"
          if(sc!==ysc && ysm.includes(b.toString())){
            const nid=[];const nold=[];
            nid[0]=id;
            nold[0]=tt[id];
            dispatch(delTabplateStoSc1({id:id,sc:sc,sh:3,sl:b-1,nid:nid,old:nold,un:un}))
          }
        };
        break;
      case (e === 1 && p && c > 0):
        // 删除所有单元格内候选数的某类背景色
        if(ysh===3){
          const a="a" + c.toString();
          const b="b" + c.toString();
          let nid=[];let nold=[];let scnew=[]
          tt.forEach((item,index)=>{
            if(item.sc.includes(a) || item.sc.includes(b)){
              nid.push(index);
              nold.push(item)
              const ysca=item.sc.map(ysc => (ysc === a || ysc === b ? "0" : ysc));
              scnew.push(ysca);
            }
          });
          dispatch(delTabplateStoSc3({id:id,sh:3,nid:nid,old:nold,scnew:scnew,un:un}))
        };
        break;
      case (e>0 && p && c === 0 && b > 0):
        // 删除小数字(候选数)
        if(ysh===3){
          const sm=changsml(ysm,"b0",b-1)
          const sc="0"
          if(sm!==ysm){
            const nid=[];const nold=[];
            nid[0]=id;
            nold[0]=tt[id];
            if(sm==="b0b0b0b0b0b0b0b0b0"){
              dispatch(delTabplateStoSm({id:id,sm:sm,sc:sc,sh:0,sl:b-1,nid:nid,old:nold,un:un}))
            }else{
              dispatch(delTabplateStoSm({id:id,sm:sm,sc:sc,sh:3,sl:b-1,nid:nid,old:nold,un:un}))
            }
          }
        };
        break;
      default:
        break; 
    };
  };
  
  //单元格块
  const divkuai=[];
  for(let i=0;i<=80;i++){
    divkuai[i]=(
      <div id={i} key={i} onClick={clickcell}
        className={`${styles.dbg} ${styles[bo[i]]}`}
        style={bg[i]}
      >
        <div className={`${styles.divti} ${ow[i][0]}`} style={buttonStyle}>
          <span style={cc[i][0]}>{zz[i][0]}</span>
        </div>
        <div className={`${styles.divko} ${ow[i][1]}`}>
          <span style={cc[i][1]}>{zz[i][1]}</span>
        </div>
        <div className={`${styles.divhx} ${ow[i][2]}`}>
          <div>
            <span style={{...k[i][0],...hc[i][0]}}>{z[i][0]}</span>
            <span style={{...k[i][1],...hc[i][1]}}>{z[i][1]}</span>
            <span style={{...k[i][2],...hc[i][2]}}>{z[i][2]}</span>
            <span style={{...k[i][3],...hc[i][3]}}>{z[i][3]}</span>
            <span style={{...k[i][4],...hc[i][4]}}>{z[i][4]}</span>
            <span style={{...k[i][5],...hc[i][5]}}>{z[i][5]}</span>
            <span style={{...k[i][6],...hc[i][6]}}>{z[i][6]}</span>
            <span style={{...k[i][7],...hc[i][7]}}>{z[i][7]}</span>
            <span style={{...k[i][8],...hc[i][8]}}>{z[i][8]}</span>
          </div>
        </div>
      </div>
    )
  };

  return (
    <>
    <Ratio aspectRatio={"1x1"}>
    <div className={`${styles.tablediv} py-2 pe-2`} style={{backgroundColor:tb}}>
      <table className={`text-center ${cur}`}>
      <tbody>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>A</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[0]}</td>
          <td className={styles.btop}>{divkuai[1]}</td>
          <td className={styles.btop}>{divkuai[2]}</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[3]}</td>
          <td className={styles.btop}>{divkuai[4]}</td>
          <td className={styles.btop}>{divkuai[5]}</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[6]}</td>
          <td className={styles.btop}>{divkuai[7]}</td>
          <td className={`${styles.btop} ${styles.bright}`}>{divkuai[8]}</td>
        </tr>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>B</td>
          <td className={styles.bleft}>{divkuai[9]}</td>
          <td>{divkuai[10]}</td>
          <td>{divkuai[11]}</td>
          <td className={styles.bleft}>{divkuai[12]}</td>
          <td>{divkuai[13]}</td>
          <td>{divkuai[14]}</td>
          <td className={styles.bleft}>{divkuai[15]}</td>
          <td>{divkuai[16]}</td>
          <td className={styles.bright}>{divkuai[17]}</td>
        </tr>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>C</td>
          <td className={styles.bleft}>{divkuai[18]}</td>
          <td>{divkuai[19]}</td>
          <td>{divkuai[20]}</td>
          <td className={styles.bleft}>{divkuai[21]}</td>
          <td>{divkuai[22]}</td>
          <td>{divkuai[23]}</td>
          <td className={styles.bleft}>{divkuai[24]}</td>
          <td>{divkuai[25]}</td>
          <td className={styles.bright}>{divkuai[26]}</td>
        </tr>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>D</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[27]}</td>
          <td className={styles.btop}>{divkuai[28]}</td>
          <td className={styles.btop}>{divkuai[29]}</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[30]}</td>
          <td className={styles.btop}>{divkuai[31]}</td>
          <td className={styles.btop}>{divkuai[32]}</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[33]}</td>
          <td className={styles.btop}>{divkuai[34]}</td>
          <td className={`${styles.btop} ${styles.bright}`}>{divkuai[35]}</td>
        </tr>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>E</td>
          <td className={styles.bleft}>{divkuai[36]}</td>
          <td>{divkuai[37]}</td>
          <td>{divkuai[38]}</td>
          <td className={styles.bleft}>{divkuai[39]}</td>
          <td>{divkuai[40]}</td>
          <td>{divkuai[41]}</td>
          <td className={styles.bleft}>{divkuai[42]}</td>
          <td>{divkuai[43]}</td>
          <td className={styles.bright}>{divkuai[44]}</td>
        </tr>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>F</td>
          <td className={styles.bleft}>{divkuai[45]}</td>
          <td>{divkuai[46]}</td>
          <td>{divkuai[47]}</td>
          <td className={styles.bleft}>{divkuai[48]}</td>
          <td>{divkuai[49]}</td>
          <td>{divkuai[50]}</td>
          <td className={styles.bleft}>{divkuai[51]}</td>
          <td>{divkuai[52]}</td>
          <td className={styles.bright}>{divkuai[53]}</td>
        </tr>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>G</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[54]}</td>
          <td className={styles.btop}>{divkuai[55]}</td>
          <td className={styles.btop}>{divkuai[56]}</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[57]}</td>
          <td className={styles.btop}>{divkuai[58]}</td>
          <td className={styles.btop}>{divkuai[59]}</td>
          <td className={`${styles.btop} ${styles.bleft}`}>{divkuai[60]}</td>
          <td className={styles.btop}>{divkuai[61]}</td>
          <td className={`${styles.btop} ${styles.bright}`}>{divkuai[62]}</td>
        </tr>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>H</td>
          <td className={styles.bleft}>{divkuai[63]}</td>
          <td>{divkuai[64]}</td>
          <td>{divkuai[65]}</td>
          <td className={styles.bleft}>{divkuai[66]}</td>
          <td>{divkuai[67]}</td>
          <td>{divkuai[68]}</td>
          <td className={styles.bleft}>{divkuai[69]}</td>
          <td>{divkuai[70]}</td>
          <td className={styles.bright}>{divkuai[71]}</td>
        </tr>
        <tr>
          <td className={`${styles.nobright} ${styles.fontarial}`}>I</td>
          <td className={`${styles.bleft} ${styles.bbottom}`}>{divkuai[72]}</td>
          <td className={styles.bbottom}>{divkuai[73]}</td>
          <td className={styles.bbottom}>{divkuai[74]}</td>
          <td className={`${styles.bleft} ${styles.bbottom}`}>{divkuai[75]}</td>
          <td className={styles.bbottom}>{divkuai[76]}</td>
          <td className={styles.bbottom}>{divkuai[77]}</td>
          <td className={`${styles.bleft} ${styles.bbottom}`}>{divkuai[78]}</td>
          <td className={styles.bbottom}>{divkuai[79]}</td>
          <td className={`${styles.bright} ${styles.bbottom}`}>{divkuai[80]}</td>
        </tr>
        <tr>
          <td className={styles.nob}> </td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>1</td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>2</td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>3</td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>4</td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>5</td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>6</td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>7</td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>8</td>
          <td className={`${styles.nobtop} ${styles.fontarial}`}>9</td>
        </tr>
      </tbody>
      </table>
    </div>
    </Ratio>
    <Modal show={showAlert} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{langList.tabbr1[lg]}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stack direction="horizontal" gap={3} className="justify-content-center">
          <img src='./pic/trophy.svg' alt='' width={"15%"} height={"15%"}/>
          <div className='text-center'><h5>{langList.tabbr2[lg]}</h5></div>
        </Stack>
      </Modal.Body>
      <Modal.Footer className='justify-content-center'>
        <Button variant="primary" onClick={handleClose} className='w-25'>
          {langList.public9[lg]}
        </Button>
      </Modal.Footer>
    </Modal>
    
  </>
  )
};
